import PropTypes from 'prop-types';

/**
 * Filename with middle ellipsis: truncates the basename while keeping the
 * extension always visible. The full name shows on hover via the title
 * attribute.
 *
 *   "1_Platform_Architecture_E2E_Diagram_v3.pdf" → "1_Platform_Archi….pdf"
 *
 * Standard pattern for narrow sidebars (Linux Files, GitHub PR file list,
 * GitLab) where the extension is information-dense.
 */
export function Filename({ name, className = '' }) {
  const dot = name.lastIndexOf('.');
  const hasExt = dot > 0 && dot < name.length - 1;
  const base = hasExt ? name.slice(0, dot) : name;
  const ext = hasExt ? name.slice(dot) : '';

  return (
    <span className={`flex min-w-0 ${className}`} title={name}>
      <span className="truncate">{base}</span>
      {ext && <span className="shrink-0">{ext}</span>}
    </span>
  );
}

Filename.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
};
